export default {
  getMainRoomId(group) {
    const mainRoomIds = [];
    group.forEach(room => {
      mainRoomIds.push(room.layout.mainroom);
    });
    return mainRoomIds;
  },
};
